import { List } from 'immutable';

import { ToastOptions } from 'components/Toast';
import uuid from 'uuid/v4';

import { errorFragment, errorFragment_fieldErrors } from 'src/queries/__generated__/errorFragment';

export type ToastKind = 'success' | 'error' | 'custom';

export type Toast = {
  uuid: string;
  text: string;
  kind: ToastKind;
  options?: ToastOptions;
};

export type State = List<Toast>;
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export const initialState: State = new List();

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'toasts/ADD':
      return state.push(action.toast);
    case 'toasts/REMOVE':
      return state.remove(state.indexOf(action.toast));
    default:
      return state;
  }
}

export type AddAction = {
  type: 'toasts/ADD';
  toast: Toast;
};

export function add(toast: Toast): AddAction {
  return {
    type: 'toasts/ADD',
    toast,
  };
}

type RemoveAction = {
  type: 'toasts/REMOVE';
  toast: Toast;
};

export function remove(toast: Toast): RemoveAction {
  return {
    type: 'toasts/REMOVE',
    toast,
  };
}

// helper for the add action, to create new toast.
export function showToast(text: string, kind: ToastKind, options?: ToastOptions): AddAction {
  if (options) {
    return add({ uuid: uuid(), text, kind, options });
  }
  return add({ uuid: uuid(), text, kind });
}

export type APIErrorType = {
  field_errors?: any;
  message?: string;
  code?: string;
};

// helper for the add action, to create toast from API response.
export function showAPIErrorToast(error: APIErrorType): AddAction {
  let text;

  if (error.code === 'validation_error') {
    text = error.field_errors.map((err: any) => err.messages.join(', ')).join(', ');
  } else if (error.message) {
    text = error.message;
  } else {
    text = 'An error occurred.';
  }

  return add({ uuid: uuid(), text, kind: 'error' });
}

// helper for the add action, to create toast from GQL response.
export function showGQLErrorToast(error: errorFragment): AddAction {
  let text;

  if (error.code === 'validation_error') {
    text = error.fieldErrors.map((err) => err.message).join(', ');
  } else if (error.message) {
    text = error.message;
  } else {
    text = 'An error occurred.';
  }

  return add({ uuid: uuid(), text, kind: 'error' });
}

export type ToastActions = AddAction | RemoveAction;
